import { RobotProps } from '../robot/robot.types';

export const getShouldShowCurrentAnswersStatus = (
    props: Pick<RobotProps, 'isEvaluable' | 'evaluated' | 'showCurrentAnswersStatus'>
) => {
    if (props.isEvaluable && !props.evaluated) {
        return false;
    }
    return props.showCurrentAnswersStatus !== false;
};
